import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import descriptionSegment from "../../../constants/descriptionStyle.json";
import _ from "lodash";
import ImageView from "../ImageView/ImageView";
import { getImageUrl } from "Common/utils/ImageDomain";
import ReactSelect from "../ReactSelect/ReactSelect";
import ImageData from "../customImage/ImageSegment";
import Button from "../ButtonComponent/Button";
import DynamicLink from "../DynamicLink/DynamicLink";
import Modal from "../Modal";
import SolutionSegmentCard from "../SolutionSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import { showNotification } from "Common/utils/Notification";

const SolutionSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const [buttons, setButtons] = useState(data?.segments ? data?.segments : []);
  const [imageUrl, setImageUrl] = useState(data?.image_url);
  const [indexLink, setIndexLink] = useState<any>("");
  const [showLink, setShowLink] = useState<any>(false);
  const toggleLink = () => setShowLink(!showLink);
  const [dynamicLink, setDynamicLink] = useState<any>("");
  const [imageAlt, setImageAlt] = useState<any>(data?.image_alt_text);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [headerText, setHeaderText] = useState(data?.header_text);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [saticStyle, setStaticStyle] = useState<any>();
  const [styleType, setStyleType] = useState("");
  const [index, setIndex] = useState(undefined);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [subHeaderText, setSubHeaderText] = useState(data?.subheader_text);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [indexBack, setIndexBack] = useState(undefined);
  const [errors, setErrors] = useState<any>({
    buttons: buttons?.map(() => ({
      header_text: "",
      description: "",
      image_url: "",
    })),
  });

  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.media_url) {
      //setImageUrl(eventData?.media_url);
      if (index === undefined) {
        handleInputChange(undefined, undefined, eventData.media_url);
      } else {
        handleInputChange(index, "image_url", eventData.media_url);
      }
    }
  }, [eventData, index]);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setBackgroundImage(imageData.media_url);
          setBackgroundImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  useEffect(() => {
    if (data && data?.style) {
      setStaticStyle({ label: data?.style, value: data?.style });
      setStyleType(data?.style);
    }
  }, [data]);

  const addButton = () => {
    setButtons([
      ...buttons,
      {
        header_text: "",
        description: "",
        image_url: "",
        link: "",
        segment_image_alt_text: "",
      },
    ]);
    setErrors({
      ...errors,
      buttons: [
        ...errors.buttons,
        { header_text: "", description: "", image_url: "" },
      ],
    });
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    if (index !== undefined) {
      const updatedButtons = buttons.map((button, i) =>
        i === index ? { ...button, [field]: value } : button
      );
      setButtons(updatedButtons);

      const updatedErrors = { ...errors };
      if (updatedErrors.buttons[index]) {
        updatedErrors.buttons[index][field] = "";
      }
      setErrors(updatedErrors);
    } else {
      // setImageUrl(value);
    }
  };
  const handleRemoveIcon = (index) => {
    setButtons((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index ? { ...segment, icon: "" } : segment
      )
    );
  };
  useEffect(() => {
    if (dynamicLink && dynamicLink !== "") {
      if (indexLink) {
        handleInputChange(indexLink - 1, "link", dynamicLink);
      }
    }
  }, [dynamicLink, indexLink]);
  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };
  const handleSave = async (pageId, id) => {
    const newErrors = {
      buttons: buttons?.map(() => ({
        header_text: "",
        description: "",
        image_url: "",
      })),
    };

    buttons?.forEach((award, index) => {
      if (!award.header_text.trim()) {
        newErrors.buttons[index].header_text = "Text is required.";
      }
      if (!award.description?.trim()) {
        newErrors.buttons[index].description = "Description is required.";
      }
      if (!award.image_url?.trim()) {
        newErrors.buttons[index].image_url = "Image url is required.";
      }
    });

    setErrors(newErrors);

    if (
      newErrors?.buttons?.every(
        (error) => !error.header_text && !error.description && !error.image_url
      )
    ) {
      const payload = {
        segment_type: "solution_segments",
        // image_url: imageUrl,
        header_text: headerText,
        subheader_text: subHeaderText,
        segments: buttons,
        style: styleType,
        image_alt_text: imageAlt,
        

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Solution segment updated successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          {/* <div className="flex my-4">
            {imageUrl ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={imageUrl}
                  setImageData={setEventData}
                  setImageLink={setImageUrl}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setEventData(undefined);
                      setIndex(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={toggle}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add imageUrl
              </button>
            )}
          </div> */}
        </div>
        <div className="mb-4 xl:col-span-12">
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Image Alt Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Image Alt Text"
            value={imageAlt}
            onChange={(e) => setImageAlt(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.image_alt_text}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            placeholder="Enter Banner Header Text"
            value={headerText}
            onChange={(e) => setHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Sub Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Banner Sub Header Text"
            value={subHeaderText}
            onChange={(e) => setSubHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.subheader_text}
          />
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              options={descriptionSegment}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type5"}
              versionData={{
                label: versionData?.style,
                value: versionData?.style,
              }}
            />
          </div>
        </div>
        {/* Add Button */}
        <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Solution
          </button>
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.segments?.length > 0 ? <div>Old Data</div> : null}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.segments?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <SolutionSegmentCard
                index={index}
                indexLink={indexLink}
                setIndexLink={setIndexLink}
                buttonData={button}
                handleInputChange={handleInputChange}
                errors={errors}
                removeButton={removeButton}
                isEditable={false}
                isLoading={isLoading}
                toggleLink={toggleLink}
                setIndex={setIndex}
                setDynamicLink={setDynamicLink}
                getImageUrl={getImageUrl}
                handleRemoveIcon={handleRemoveIcon}
                toggle={toggle}
                setEventData={setEventData}
              />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.segments?.length > 0 ? <div>New Data</div> : null}
        </div>
        {/* Render Buttons */}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {buttons?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <SolutionSegmentCard
                index={index}
                indexLink={indexLink}
                setIndexLink={setIndexLink}
                buttonData={button}
                handleInputChange={handleInputChange}
                errors={errors}
                removeButton={removeButton}
                isEditable={isEditable}
                isLoading={isLoading}
                toggleLink={toggleLink}
                setIndex={setIndex}
                setDynamicLink={setDynamicLink}
                getImageUrl={getImageUrl}
                handleRemoveIcon={handleRemoveIcon}
                toggle={toggle}
                setEventData={setEventData}
              />
            </div>
          ))}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
      <Modal
        show={showLink}
        onHide={toggleLink}
        id="defaultModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
        >
          <Modal.Title className="text-16">{"Add Link"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          {/* <h5 className="mb-3 text-16">{}</h5> */}
          <div className="h-[400px] text-slate-500 dark:text-zink-200">
            <DynamicLink
              showLink={showLink}
              toggleLink={toggleLink}
              setLink={setDynamicLink}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default SolutionSegment;
